module.exports = __webpack_public_path__ + "img/icon_arrow_left_white.1bb27c8a.svg";